import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ServiziPage from "@/pages/ServiziPage";
import ContattiPage from "@/pages/ContattiPage";
import RisorsePage from "@/pages/RisorsePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Chatbot from "@/components/Chatbot";
import TelcaBadge from "@/components/TelcaBadge";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <div className="App min-h-screen bg-brand-background">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/risorse" element={<RisorsePage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Chatbot />
        <WhatsAppButton />
        <TelcaBadge />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
